// extracted by mini-css-extract-plugin
export default {"root":"AddLesson_root__fSaGb","wrapper":"AddLesson_wrapper__re7mB","content":"AddLesson_content__iHIC5"};